import React from 'react'
import PropTypes from 'prop-types'
import Link from "../../components/Link/Link"
import ContentImageNetlify from '../../utilities/ContentImageNetlify'

function BlogPostTemplate({
  content,
  tags,
  title,
}) {

  const transformedContent = ContentImageNetlify(content);


  return <div className="content singular">
    <div className="content-region">
      <h1 className="title">
        {title}
      </h1>
    </div>
    <div className="content-region" dangerouslySetInnerHTML={{ __html: transformedContent }} />
    {tags && tags.nodes.length ? (
      <div className="content-region margin-top-large margin-top-medium-mobile">
        <h3 className="support-heading">Tagged</h3>
        <ul className="taxonomies support">
          {tags.nodes.map(tag => (
            <li key={`${tag.slug}tag`}>
              <Link to={`${tag.uri}`}>{tag.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    ) : null}
  </div>
}

BlogPostTemplate.defaultProps = {
  title: '',
  tags: []
}

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.string,
  tags: PropTypes.shape({
    node: PropTypes.node
  })
}


export default BlogPostTemplate
